<ng-select #organizationsSelect
           bindLabel="name"
           [items]="(organizations$ | async) ?? []"
           [typeahead]="organizationsSearchInput$"
           [minTermLength]="minSearchTermLength"
           [loading]="organizationsLoading"
           [clearable]="selectedOrganization !== 'Any'"
           [virtualScroll]="false"
           [ngStyle]="{'width': '100%'}"
           [readonly]="readOnly"
           [(ngModel)]="selectedOrganization"
           (change)="onOrganizationChange($event)"
           (search)="onSearchTermChange($event)"
           (clear)="resetCurrentSearch()"
           (open)="onDropdownOpen()"
           (close)="onDropdownClose()"
           class="default-style magnifier mb-2"
           data-identifier="users-site-select">
    <ng-template ng-header-tmp>
        <div class="row d-flex flex-row">
            <div class="col-4">
                <div><strong>Firm</strong></div>
            </div>
            <div class="col-8">
                <div><strong>URL</strong>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
        <div class="row d-flex flex-row">
            <div class="col-4">
                <div [class.text-truncate]="truncateText"
                     [title]="truncateText ? item.name : null"
                     [innerHTML]="item.name | formatSearchTermPipe: currentSearchTerm"></div>
            </div>

            <div class="col-8">
                <div [class.text-truncate]="truncateText"
                     [title]="truncateText ? item.urlHost : null"
                     [innerHTML]="item.urlHost | sanitizeUrlHost"></div>
            </div>
        </div>
    </ng-template>
    <ng-template ng-footer-tmp *ngIf="morePages">
        <p class="placeholder-color">There are more results based on your search. Type more characters to refine
            search.</p>
    </ng-template>
</ng-select>


